import { shareReplay } from 'rxjs/operators';
import { AngularFireStorage, AngularFireUploadTask } from '@angular/fire/storage';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Store } from '@ngrx/store';
import { RouterState } from '@angular/router';
import { selectStorageBasePath, selectStorageCabinetBasePath } from 'src/app/store/router/router.selectors';

@Injectable({
  providedIn: 'root'
})
export class UploadService {

  basePath$ = this.store.select(selectStorageBasePath).pipe(shareReplay(1));
  cabinetBasePath$ = this.store.select(selectStorageCabinetBasePath).pipe(shareReplay(1));

  constructor(
    private store: Store<RouterState>,
    private storage: AngularFireStorage
  ) { }

  upload(file: File, path: string): AngularFireUploadTask {
    return this.storage.upload(path, file);
  }

  ref(path: string) {
    return this.storage.ref(path);
  }

  getDownloadURL(path: string): Observable<any> {
    return this.ref(path).getDownloadURL();
  }

  getThumbnailURL(path: string, size?: '64' | '128' | '256'): Observable<any> {
    const segments = path.split('/');
    const fileName = segments.pop();
    const thumbPath = `${segments.join('/')}/thumb@256_${fileName}`;
    return this.ref(thumbPath).getDownloadURL();
  }

  delete(path: string) {
    return this.ref(path).delete();
  }

}
